<script setup></script>

<template>
  <div
    class="relative flex flex-col rounded-md bg-gradient-to-r from-[#F6F6F6] via-white to-[#F9F9F9] p-4 shadow-md ring-1 ring-gray-900/5"
  >
    <slot />
  </div>
</template>
